export default [
  {
    type: 'purposes',
    id: 1
  },
  {
    type: 'stacks',
    id: 42
  }
]
